export default __webpack_public_path__ + "static/br-f1fe13f82fc29551a053d6c9a2967177.jpg";